import { toNormalizedMessage } from '@/shared/utils/sentry/clientIgnoreRules/stringMatchers';
import {
  ClientSentryEventContext,
  ClientSentryIgnoreRule,
} from '@/shared/utils/sentry/clientIgnoreRules/types';

const ERROR_BA_MESSAGE = 'ba';

const hasActionableContext = ({
  hasExceptionStacktrace,
  hasAppFrameInStacktrace,
}: ClientSentryEventContext): boolean =>
  hasExceptionStacktrace || hasAppFrameInStacktrace;

const isErrorBaMessage = (message: unknown): boolean =>
  toNormalizedMessage(message) === ERROR_BA_MESSAGE;

export const errorBaWithoutStackContextRule: ClientSentryIgnoreRule = {
  id: 'error-ba-without-stack-context',
  references: ['FTR-3410'],
  reason:
    'Known global Error: Ba rejection without usable seller-ui stack context for triage',
  matches: (context) => {
    if (context.firstExceptionType !== 'Error') {
      return false;
    }

    if (hasActionableContext(context)) {
      return false;
    }

    return (
      isErrorBaMessage(context.serializedMessage) ||
      isErrorBaMessage(context.originalExceptionMessage)
    );
  },
};
